module.exports = __webpack_public_path__ + "img/chimney.0b7e4384.svg";